import { BodyText, Strong } from '@utilitywarehouse/hearth-react';

import {
  IOTSCommunication,
  IOTSProvider,
  IOTSSwitchOption,
  OTSServiceAction,
} from '@src/types/oneTouchSwitching';

import { commsOptionSplitterHandler } from './commsOptionsSplit';

export interface SwitchSuccessTextProps {
  provider: IOTSProvider | null;
  comms: IOTSCommunication[];
  homePhoneSuffix: string | null;
  switchingReference: string | null;
  switchOptions: IOTSSwitchOption[];
}

export const SwitchSuccessText: React.FC<SwitchSuccessTextProps> = ({
  provider,
  comms,
  homePhoneSuffix,
  switchingReference,
  switchOptions,
}) => {
  const commOptions = commsOptionSplitterHandler(comms);
  const selectedOption =
    switchOptions.find(
      (opt) => opt.switchingReference === switchingReference
    ) ?? null;

  return (
    <>
      <BodyText>
        {provider?.name} have sent you {commOptions} with details of what will
        happen when you switch.
        {selectedOption &&
          selectedOption.homePhoneAction === OTSServiceAction.ForcedCease && (
            <span>
              {' '}
              Your home phone service with {provider?.name} (ending{' '}
              <Strong>{homePhoneSuffix}</Strong>) will also be cancelled.
            </span>
          )}
      </BodyText>
    </>
  );
};
